import * as z from 'zod';

import { booleanMutationSchema } from '@/_schemas/generic';

import { inventoryVendorQuerySchema } from './inventory-vendor-query-schema';

export const inventoryVendorUpdateSchema = inventoryVendorQuerySchema
  .omit({
    phone_numbers: true,
    vendor_w9_file: true,
    sku_label: true,
    addresses: true,
  })
  .extend({
    url: z.url(),
    sku_label: z.string(),
    phone_numbers: z.array(z.number()).nullish(),
    vendor_w9_file: z.array(z.number()).nullish(),
    addresses: z.array(z.number()).nullish(),
    minimum_order_required: booleanMutationSchema(),
  });

export type InventoryVendorUpdateSchema = z.infer<typeof inventoryVendorUpdateSchema>;

export const inventoryVendorCreateSchema = inventoryVendorUpdateSchema.omit({
  id: true,
  phone_numbers: true,
  vendor_w9_file: true,
  notes: true,
});

export type InventoryVendorCreateSchema = z.infer<typeof inventoryVendorCreateSchema>;
